import React, { useEffect, useState } from "react";
import "./Hero.css";
import heroVideo from "../../assets/videos/hero-1.mp4";
import { FaInstagram, FaLinkedinIn, FaWhatsapp, FaTimes } from "react-icons/fa";

const Hero = () => {
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    const hero = document.querySelector(".hero-content");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) hero.classList.add("show-content");
          else hero.classList.remove("show-content");
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(hero);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="hero-section">
      {/* Background Video */}
      <video className="hero-video" autoPlay loop muted playsInline>
        <source src={heroVideo} type="video/mp4" />
      </video>

      <div className="hero-overlay"></div>

    {/* Desktop Icons (fixed) */}
<div className="left-social-icons desktop-only">
  <a 
    href="https://wa.me/919049442717?text=Can%20I%20get%20more%20information%20for%20this%3F" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    <FaWhatsapp />
  </a>

  <a 
    href="https://www.instagram.com/nmdinfotech/?igsh=M2lnM205YXZ6b3lp#" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    <FaInstagram />
  </a>

  <a 
    href="https://in.linkedin.com/company/nmd-infotech" 
    target="_blank" 
    rel="noopener noreferrer"
  >
    <FaLinkedinIn />
  </a>
</div>






      {/* Hero Content */}
      <div className="hero-content">
        <span className="hero-tagline">
           NMD is one of the leading business consulting and IT company
         
        </span>

         <h1>
          Innovate, Analyze, <span className="highlight-blue">Succeed</span> – 
          Your Trusted IT Partner
        </h1> 
      
        {/* <p>
          Empowering Your Business Presence With 
          <span className="highlight-yellow"> Best Solutions </span> – NMD Services!
        </p> */}

        <button className="hero-btn" onClick={() => setShowForm(true)}>
          Enquire Now
        </button>
      </div>

      {/* Popup Enquiry Form */}
      <div className={`enquiry-form-wrapper ${showForm ? "show-form" : ""}`}>
        <div className="enquiry-form-box">
          {/* Close Icon */}
          <FaTimes className="close-icon" onClick={() => setShowForm(false)} />

          <h2>Send Enquiry</h2>

          <form action="https://api.web3forms.com/submit" method="POST">
  {/* Access Key */}
  <input
    type="hidden"
    name="access_key"
    value="157f5dfc-898c-4749-aab8-a80e612db795"
  />

  <input type="text" name="name" placeholder="Full Name *" required />
  <input type="email" name="email" placeholder="Email ID *" required />
  <input type="number" name="mobile" placeholder="Mobile Number *" required />

  <textarea name="message" placeholder="Write your message"></textarea>

  <button type="submit" className="submit-btn">Submit</button>
</form>

        </div>
      </div>
    </section>
  );
};

export default Hero;
